import React from "react";

export class TermsConditions extends React.Component<
    {
        confirmClicked: (accepted: boolean) => void
    },
    {
        //State goes here
    }
> {


    render() {

      return (
        <>
          <div className="termsContainer">

            <p>The Medistim Case Cloud provides a central repository for anonymized or de-identified clinical data generated on Medistim MiraQ and VeriQ systems to be stored and analyzed. </p>
            <br/>
            <p>Uploading of personal data requires consent from the patient to use data for the purposes of scientific, historical research, and statistical analysis.</p>
            <br/>
            <p>All data is handled according to Medistim's personal data protection policy:</p>
            <p><a target="_blank" rel="noopener noreferrer" title="personal data protection policy" href="https://medistim.com/about-us/personal-data-protection-policy/">Personal Data Protection Policy</a></p>
            
            <p className="spaceTop">Contact: <a href="mailto:casecloud@medistim.com" title="Contact Medistim CaseCloud">casecloud@medistim.com</a></p>
          <br/>
            <div className="termsAccept">
              <p className="spaceTop">I have read and accept the above.</p>
              <button className="primaryButton actionButton" onClick={()=>{this.props.confirmClicked(true);}}>Confirm</button>
            </div>
            <br/>

          </div>
        </>
        );
    }
}



